const FormField = ({ className, label, required, children }) => (
  <div className={`d-flex flex-column ${className}`}>
    <div className="d-flex gap-2">
      <b>{label}</b> {required && <b className="text-danger">*</b>}
    </div>
    {children}
  </div>
);

export default FormField;
